import { render, staticRenderFns } from "./FieldCodes.vue?vue&type=template&id=1c13a86e&scoped=true"
import script from "./FieldCodes.vue?vue&type=script&lang=js"
export * from "./FieldCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c13a86e",
  null
  
)

export default component.exports